var _path, _rect, _rect2, _rect3, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFamilyTrust = function SvgFamilyTrust(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 424,
    height: 94,
    fill: "none",
    viewBox: "0 0 424 94"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M212.5 37.5h-1v-16h1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 226,
    y: 68.5,
    fill: "#4B5563",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 178,
    y: 68.5,
    fill: "#4B5563",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    x: 196,
    y: 32.5,
    fill: "#4B5563",
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M188.5 65.669a3.5 3.5 0 0 1 3.5-3.5h16a4.5 4.5 0 0 0 4.5-4.5V52.5h-1v5.169a3.5 3.5 0 0 1-3.5 3.5h-16a4.5 4.5 0 0 0-4.5 4.5V68.5h1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M235.5 65.669a3.5 3.5 0 0 0-3.5-3.5h-16a4.5 4.5 0 0 1-4.5-4.5V52.5h1v5.169a3.5 3.5 0 0 0 3.5 3.5h16a4.5 4.5 0 0 1 4.5 4.5V68.5h-1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 211.667,
    cy: 13.5,
    r: 8,
    fill: "#4B5563"
  })));
};
export default SvgFamilyTrust;